import { useState } from "react";

import { useForm } from "react-hook-form";

import usePartMutations from "../../../data/usePartMutations";
import useApiHelper from "../../../hooks/useApiHelper";
import { IPart } from "../../../models/Part";
import Card from "../../shared/Card/Card";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import { RadioGroupInput } from "../../shared/Inputs/RadioGroupInput";
import { TextInput } from "../../shared/Inputs/TextInput";
import PinProtect, { PinProtectState } from "../../shared/PinProtect";
import apiConfig from "../../../utils/apiConfig";

export default function PartQc({ part }: { part: IPart }) {
  const { post } = useApiHelper(apiConfig("PartQc"));
  const { partQc } = usePartMutations();

  const [pinModalOpen, setPinModalOpen] = useState(false);
  const [pinState, setPinState] = useState<PinProtectState>();

  const { register, handleSubmit, watch, setValue } = useForm<any>({
    defaultValues: {
      qcStatus: "0",
      qcApprovedComment: part.qcApprovedComment || "",
    },
  });

  const onSubmit = async (data: any) => {
    console.log("Data", data);

    setPinModalOpen(true);

    setPinState({
      onPinSuccess: () => {
        partQc.mutateAsync({
          partId: part.id,
          qcStatus: data.qcStatus,
          qcApprovedComment: data.qcApprovedComment,
        }, {
          onSuccess: () => {
            console.log("Part QC updated successfully");
          },
          onError: (error) => {
            console.error("Error updating Part QC", error);
          },
        });
      },
      onPinFailed: () => { },
      pinLabel: "Submit Tracking Information",
    });


  }

  return (
    <Card bodyClassName="p-4 flex flex-col divide-y gap-y-4" title="Part QC">
      <PinProtect
        open={pinModalOpen}
        setOpen={setPinModalOpen}
        pinState={pinState}
      />

      <div className="flex flex-col gap-2">
        <h1 className="font-semibold text-gray-600">Reason:</h1>
        <p>{part.qcReason || "No reason provided"}</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 pt-2">
        <TextInput
          label={"Comment"}
          register={register}
          registerName={"qcApprovedComment"}
          richText={true}
          rounded
        />

        <RadioGroupInput
          register={register}
          registerName={"qcStatus"}
          watch={watch}
          setValue={setValue}
          options={[
            { name: "In Progress", value: "0" },
            { name: "Passed", value: "1" },
            { name: "Failed", value: "2" },
          ]}
        />

        <ButtonInput
          label="Submit QC"
          isSubmit={true}
          onClick={() => { }}
          classes={"mt-4"}
        />
      </form>
    </Card>
  )
}